import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useDispatch, useSelector } from 'react-redux';
import apiRequest from '../../../../api/request';
import { getCroLeadsAll } from '../../../../redux/features/croSlice';

const syncedSx = {
  background: 'linear-gradient(135deg, rgb(34, 160, 107), rgb(0, 139, 208))',
  color: '#fff',
  border: 'none',
  '&:hover': {
    background: 'linear-gradient(135deg, rgb(24, 130, 87), rgb(0, 110, 170))',
    border: 'none',
  },
};

// Pushes the lead's student to SmartTest right away, whatever the lead status.
// Admission confirm already does this automatically; this button is for
// retries and for any other student that needs syncing.
// smartest_synced_at (from CRO Leads) marks students already synced; the
// button stays clickable so they can be synced again.
const SyncToSmartest = ({ rowData, dispatchdata }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [syncing, setSyncing] = useState(false);
  const [justSynced, setJustSynced] = useState(false);

  // rowData is a copy taken when the row was clicked, so it misses the list
  // refresh after a sync. Read the same row from the latest list instead.
  const freshRow = useSelector((state) =>
    state.cro.croLeadsAll?.data?.find((r) => r.course_enrollment_id === rowData?.course_enrollment_id),
  );
  const synced = justSynced || Boolean(freshRow?.smartest_synced_at || rowData?.smartest_synced_at);

  // The drawer reuses this component when another row is opened.
  useEffect(() => {
    setJustSynced(false);
  }, [rowData?.course_enrollment_id]);

  if (!rowData?.cro_assignment_id) return null;

  const handleSync = async () => {
    setSyncing(true);
    // apiRequest resolves with the error body instead of rejecting.
    const res = await apiRequest({
      url: `smartest/sync-cro-assignment/${rowData.cro_assignment_id}`,
      method: 'post',
    });
    setSyncing(false);
    const ok = res?.status === 'success';
    if (ok) {
      setJustSynced(true);
      if (dispatchdata) dispatch(getCroLeadsAll(dispatchdata)); // picks up smartest_synced_at
    }
    enqueueSnackbar(res?.message || 'Could not sync to SmartTest', { variant: ok ? 'success' : 'error' });
  };

  let label = 'Sync to SmartTest';
  if (syncing) label = 'Syncing...';
  else if (synced) label = 'Synced to SmartTest';

  return (
    <Button
      size="medium"
      variant={synced ? 'contained' : 'outlined'}
      color="secondary"
      sx={synced ? syncedSx : undefined}
      disabled={syncing}
      onClick={handleSync}
      startIcon={<Icon icon={synced ? 'mdi:check-circle' : 'mdi:sync'} width="18" height="18" />}
      title={synced ? 'Already in SmartTest. Click to sync again.' : undefined}
    >
      {label}
    </Button>
  );
};

export default SyncToSmartest;
